// extracted by mini-css-extract-plugin
export default {"mainContainer":"editCommentComponent_mainContainer__LiDpF"};